import { Reveal } from "@/components/common";
import { PACKAGES } from "@/lib/data";
import { PriceCard } from "@/components/PriceCard";
import { useCtaActions } from "@/lib/ctaActions";
import { useI18n } from "@/i18n";
import { ExtraInfo } from "@/components/sections/ExtraInfo";
import { PricingTable } from "@/components/sections/PricingTable";

export function Pricing() {
  const { goPackage } = useCtaActions();
  const { t } = useI18n();
  const dictPkgs = t("pricing.packages");
  const vatLabel = t("app.billing.exclVat");
  const period = t("pricing.perMonth");
  // Merge non-translatable pricing meta (id, price, recommended) with localized copy.
  const packages = PACKAGES.map((p, i) => ({ ...p, ...dictPkgs[i], period }));
  return (
    <section id="pakketten" className="overflow-visible bg-white py-24 md:py-32" data-testid="pricing">
      <div className="container-re">
        <Reveal className="mx-auto max-w-2xl px-2 text-center">
          <h2 className="pb-1 font-heading text-3xl font-black leading-[1.12] tracking-tight text-re-ink md:text-5xl">
            {t("pricing.title")} <span className="text-gradient-red">{t("pricing.titleAccent")}</span>{t("pricing.titleEnd")}
          </h2>
          <p className="mt-5 text-base text-re-muted md:text-lg">
            {t("pricing.sub")}
          </p>
        </Reveal>

        <div className="mx-auto mt-16 grid max-w-6xl items-center gap-6 md:grid-cols-3 md:gap-5">
          {packages.map((p, i) => (
            <PriceCard key={p.id} pkg={p} index={i} onSelect={() => goPackage(p.id)} vatLabel={vatLabel} />
          ))}
        </div>

        {/* Extra package information (housing credits) */}
        <ExtraInfo />

        {/* Compact comparison */}
        <PricingTable />
      </div>
    </section>
  );
}
